<template>
  <va-create-layout>
    <clubs-form :title="title" :item="item"></clubs-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
